<template>
    <div>
        <!-- Trip Swap Header Section - Styled to match Figma design -->
        <div class="mb-6 overflow-hidden relative">
            <!-- Background pattern and planes -->
            <img
                src="/images/tripswap/heroimage.svg"
                alt="Trip Swap Hero Image"
                class="mx-auto w-full max-w-4xl -mt-24 md:-mt-48"
            />
            <img
                src="/images/tripswap/leftplane.svg"
                alt=""
                class="absolute -left-8 top-0 lg:-top-8 w-48 md:w-64 lg:w-96 h-32 sm:h-48 md:h-64 lg:h-96 transform -rotate-6"
            />
            <img
                src="/images/tripswap/rightplane.svg"
                alt=""
                class="absolute -right-8 top-0 lg:-top-24 w-48 md:w-64 lg:w-96 h-32 sm:h-48 md:h-64 lg:h-96 transform rotate-6"
            />

            <div
                class="max-w-7xl mx-auto px-6 pb-12 relative -mt-36 md:-mt-64 lg:-mt-72"
            >
                <!-- Centered title -->
                <div class="flex flex-col items-center mb-12">
                    <!-- Main Heading -->
                    <h1 class="text-center mb-2">
                        <span
                            class="text-2xl lg:text-3xl font-bold text-orange"
                        >
                            Trip Swap
                        </span>
                        <span
                            class="text-2xl lg:text-3xl font-bold text-slate-800"
                        >
                            — exchange trips with
                        </span>
                        <br />
                        <span
                            class="text-2xl lg:text-3xl font-bold text-slate-800"
                        >
                            fellow My10x members!
                        </span>
                    </h1>
                </div>

                <!-- Three column feature list -->
                <div
                    class="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto"
                >
                    <!-- Column 1: Exchange with My10x members -->
                    <div class="flex flex-col items-center md:items-start">
                        <div class="bg-orange rounded-full mb-4">
                            <Icon
                                icon="check"
                                class="text-white"
                                :height="20"
                                :width="20"
                            />
                        </div>
                        <h3 class="font-medium text-slate-800 text-lg mb-2">
                            Exchange with My10x members
                        </h3>
                        <p class="text-sm">
                            Trip Swap connects you with fellow My10x members who
                            are looking to exchange their travel plans. Think of
                            it like HomeSwap, but for your meticulously planned
                            award redemptions.
                        </p>
                    </div>

                    <!-- Column 2: Accept swaps you like -->
                    <div class="flex flex-col items-center md:items-start">
                        <div class="bg-orange rounded-full mb-4">
                            <Icon
                                icon="check"
                                class="text-white"
                                :height="20"
                                :width="20"
                            />
                        </div>
                        <h3 class="font-medium text-slate-800 text-lg mb-2">
                            Accept swaps you like
                        </h3>
                        <p class="text-sm">
                            Simply accept it and our dedicated concierge team
                            will handle all the logistics behind the scenes -
                            rebooking flights, transferring hotel reservations,
                            and adjusting point redemptions.
                        </p>
                    </div>

                    <!-- Column 3: No calls, no fees, no stress -->
                    <div class="flex flex-col items-center md:items-start">
                        <div class="bg-orange rounded-full mb-4">
                            <Icon
                                icon="check"
                                class="text-white"
                                :height="20"
                                :width="20"
                            />
                        </div>
                        <h3 class="font-medium text-slate-800 text-lg mb-2">
                            No calls, no fees, no stress
                        </h3>
                        <p class="text-sm">
                            Just click "Accept Swap" and within 24 hours you'll
                            receive your new travel itinerary via email. Our
                            premium concierge service ensures a seamless
                            transition to your exciting new destination!
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Load the full Trip Swap component -->
        <TripSwap />
    </div>
</template>

<script>
// Import TripSwap component
import TripSwap from './trip-swap.vue';
import Icon from '@/components/ui/icon/icon.vue'; // Import Icon component

export default {
    name: 'TripSwapEntry',
    components: {
        TripSwap,
        Icon, // Register Icon component
    },
};
</script>
